export default {
  tap: {
    en: 'Tap to rate',
  },
  click: {
    en: 'Click to rate',
  },
  byRating: {
    5: {
      en: 'Amazing',
    },
    4: {
      en: 'Very good',
    },
    3: {
      en: 'Pretty good',
    },
    2: {
      en: 'Needs improvement',
    },
    1: {
      en: 'Not for me',
    },
  },
}
